export default {
  opponentRank: {
    rankSummary: "Puesto {{rank}} en {{marketName}}",
    feedSubtitle: "Ranking DEF de {{team}}",
  },
};